/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `Traction` - Traction
 * * `Hydro` - Hydro
 * * `Other` - Other
 * * `escalator` - Escalator
 * * `hydraulic-passenger` - Hydraulic Passenger
 * * `hydraulic-service` - Hydraulic Service
 * * `mrl-traction` - MRL Traction
 * * `geared-passenger` - Geared Passenger
 * * `geared-traction` - Geared Traction
 * * `gearless-traction` - Gearless Traction
 * * `gearless-passenger` - Gearless Passenger
 * * `wheelchair-lift` - Wheelchair Lift
 * * `dumbwaiter` - Dumbwaiter
 * * `passenger-service` - Passenger/Service
 * * `high-rise-passenger` - High Rise Passenger
 * * `low-rise-passenger` - Low Rise Passenger
 * * `passenger` - Passenger
 * * `freight` - Freight
 */
export type ElevatorTypeEnum = typeof ElevatorTypeEnum[keyof typeof ElevatorTypeEnum];


export const ElevatorTypeEnum = {
  Traction: 'Traction',
  Hydro: 'Hydro',
  Other: 'Other',
  escalator: 'escalator',
  'hydraulic-passenger': 'hydraulic-passenger',
  'hydraulic-service': 'hydraulic-service',
  'mrl-traction': 'mrl-traction',
  'geared-passenger': 'geared-passenger',
  'geared-traction': 'geared-traction',
  'gearless-traction': 'gearless-traction',
  'gearless-passenger': 'gearless-passenger',
  'wheelchair-lift': 'wheelchair-lift',
  dumbwaiter: 'dumbwaiter',
  'passenger-service': 'passenger-service',
  'high-rise-passenger': 'high-rise-passenger',
  'low-rise-passenger': 'low-rise-passenger',
  passenger: 'passenger',
  freight: 'freight',
} as const;
